import { render, staticRenderFns } from "./BigNumberReport.vue?vue&type=template&id=7b155592"
import script from "./BigNumberReport.vue?vue&type=script&lang=ts"
export * from "./BigNumberReport.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports